(function () {
  'use strict';

  // Custom namespace for Curacao (avoid mixing with vendor theme namespaces).
  window.Curacao = window.Curacao || {};

  /**
   * Zip code inputs: numeric only, max 5 chars.
   * @param {Document|Element} container
   */
  function init(container) {
    const root = container || document;
    if (!root || !root.querySelectorAll) return;

    const inputs = root.querySelectorAll('input.product-store-default-zip-code');
    if (!inputs || !inputs.length) return;

    inputs.forEach(function (zipCodeInput) {
      if (!zipCodeInput || zipCodeInput.dataset.zipCodeNumericInit === '1') return;
      zipCodeInput.dataset.zipCodeNumericInit = '1';

      zipCodeInput.addEventListener('keydown', function (e) {
        const key = e.key;
        const ctrlKey = e.ctrlKey;
        const metaKey = e.metaKey;

        const allowedKeys = [
          'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
          'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
          'Home', 'End'
        ];

        if (ctrlKey || metaKey) {
          if (['a', 'c', 'v', 'x'].includes(key.toLowerCase())) {
            return true;
          }
        }

        if (allowedKeys.includes(key)) {
          return true;
        }

        if (!/^\d$/.test(key)) {
          e.preventDefault();
          return false;
        }

        const selectionLength = this.selectionEnd - this.selectionStart;
        const remainingLength = this.value.length - selectionLength;
        if (remainingLength >= 5) {
          e.preventDefault();
          return false;
        }
      });

      zipCodeInput.addEventListener('input', function (e) {
        const input = e.target;
        const originalValue = input.value;
        const sanitizedValue = originalValue.replace(/\D/g, '').slice(0, 5);

        if (originalValue !== sanitizedValue) {
          const cursorPosition = input.selectionStart;
          input.value = sanitizedValue;
          const newPosition = Math.min(
            cursorPosition - (originalValue.length - sanitizedValue.length),
            sanitizedValue.length
          );
          input.setSelectionRange(newPosition, newPosition);
        }
      });

    });
  }

  window.Curacao.ZipCodeInput = { init: init };
})();
